import React from "react";
import {
  FormGroup,
  Button,
  Input,
  Label,
  Row,
  Col,
  Table,
  TabPane,
} from "reactstrap";
import DataCombobox from "components/DataCombobox";
import numeral from "numeral";
import api from "../../api";
import "./index.css";
import t from "utils/Lang";

export default class SiteFinancialProjection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: this.props.site,
      sisterStore: null,
      metricsList: [],
      siteFinancialProjectionMetrics: null,
      isLoadingAIModelMetrics: false,
    };
  }
  UNSAFE_componentWillMount() {
    const { site, siteId } = this.props;
    if (site) {
      if (!site.id) site.id = siteId;
      this.getSisterStoreTimeSeriesMetrics();
    }
  }
  componentDidUpdate(prevProps) {
    const { attributeName } = this.props;
    if (prevProps.site[attributeName] !== this.props.site[attributeName]) {
      this.setState({
        site: this.props.site,
      });
    }
  }
  componentDidMount() {
    this.getSiteProjectionMetrics();
    this.getAIModelSiteProjectionMetrics();
    // this.getSitePerformanceProjectionMetrics();
  }
  updateAttr(attribute, value) {
    const { siteFinancialProjectionMetrics } = this.state;
    if (value == "") value = null;
    siteFinancialProjectionMetrics[attribute] = value;
    this.setState({ siteFinancialProjectionMetrics });
  }
  async setSisterStore(sisterStore) {
    const { site, siteId } = this.props;
    api.fetchAPI({
      method: "post",
      uri: `site/${site.id || siteId}/sister_store`,
      body: sisterStore,
      success: (response) => {
        if (response.status == "ok") {
          this.setState(
            {
              sisterStore,
            },
            this.getSisterStoreTimeSeriesMetrics
          );
        }
      },
    });
  }
  getSisterStoreTimeSeriesMetrics() {
    const { sisterStore, siteFinancialProjectionMetrics } = this.state;
    if (sisterStore) {
      api.fetchAPI({
        method: "get",
        uri: `store/${sisterStore.id}/metrics/time_series/avg`,
        success: (response) => {
          console.log("sister store metrics", response);
          if (response.status === "ok") {
            siteFinancialProjectionMetrics.store_sister_average_ticket_value =
              response.result.average_order_value;
            siteFinancialProjectionMetrics.store_sister_average_group_size =
              response.result.average_cups_per_order;
            this.setState({
              siteFinancialProjectionMetrics,
            });
          }
        },
      });
    }
  }
  getSiteProjectionMetrics() {
    const { site, siteId } = this.props;
    if (!site.id) return;
    api.fetchAPI({
      method: "get",
      uri: `site/${site.id || siteId}/financial_projection_metrics`,
      success: (response) => {
        if (response.status == "ok") {
          this.setState({
            metricsList: response.metrics_list,
            siteFinancialProjectionMetrics: response.result.data,
            sisterStore: response.result.sister_store
              ? response.result.sister_store
              : null,
          });
        }
      },
    });
  }
  getAIModelSiteProjectionMetrics(isPost = false) {
    this.setState({ isLoadingAIModelMetrics: true });
    const { site, siteId } = this.props;
    if (!site.id || !siteId) return;
    api.fetchAPI({
      method: isPost ? "post" : "get",
      uri: `siteaifinancialprojectionmodelapi/site_ml/${site.id || siteId}`,
      success: (response) => {
        if (response.status == "ok") {
          this.setState({
            metricsList: response.metrics_list,
            aiModelSiteFinancialProjectionMetrics: response.result.data,
            isLoadingAIModelMetrics: false,
          });
        } else {
          // alert(response.message);
          this.setState({
            isLoadingAIModelMetrics: false,
          });
        }
      },
      error: (json) => {
        // alert(json.message);
        this.setState({
          isLoadingAIModelMetrics: false,
        });
      },
    });
  }
  getSitePerformanceProjectionMetrics() {
    this.setState({ isLoadingAIModelMetrics: true });
    const { site, siteId } = this.props;
    if (!site.id) return;
    api.fetchAPI({
      method: "get",
      uri: `site_comment/${site.id || siteId}/performance_estimation`,
      success: (response) => {
        if (response.status == "ok") {
          this.setState({
            sitePerformanceEstimations: response.result,
            isLoadingAIModelMetrics: false,
          });
        } else {
          alert(response.message);
          this.setState({
            isLoadingAIModelMetrics: false,
          });
        }
      },
      error: (json) => {
        alert(json.message);
        this.setState({
          isLoadingAIModelMetrics: false,
        });
      },
    });
  }
  saveData() {
    const { siteFinancialProjectionMetrics } = this.state;
    const { site, siteId } = this.props;

    siteFinancialProjectionMetrics.site_id = site.id || siteId;

    api.fetchAPI({
      method: "post",
      uri: `site/${site.id || siteId}/financial_projection_metrics`,
      body: siteFinancialProjectionMetrics,
      success: (response) => {
        if (response.status == "ok") {
          this.setState({
            siteFinancialProjectionMetrics: response.result.data,
          });
        } else {
          console.error("financial_projection_metrics", response.message);
          if (response.message) alert(response.message);
        }
      },
    });
  }
  renderMetrics(metric_code_name, noFormat = false, defaultValue = null) {
    const { metricsList, siteFinancialProjectionMetrics } = this.state;
    const { isView } = this.props;

    const metrics = metricsList.filter(
      (eachMetrics) => eachMetrics.code_name === metric_code_name
    )[0];
    if (!metrics) return null;
    if (!siteFinancialProjectionMetrics) return null;

    let valueToDisplay = siteFinancialProjectionMetrics[metrics.code_name];
    if (noFormat) {
      valueToDisplay = siteFinancialProjectionMetrics[metrics.code_name];
    } else {
      if (metrics.metrics_type == "number") {
        valueToDisplay = numeral(
          siteFinancialProjectionMetrics[metrics.code_name]
        ).format("0,0");
        // } else if (metrics.metrics_type == 'percentage') {
        //     valueToDisplay = numeral(siteFinancialProjectionMetrics[metrics.code_name]).format('0.00%');
      } else {
        valueToDisplay = siteFinancialProjectionMetrics[metrics.code_name];
      }
    }

    if (!siteFinancialProjectionMetrics[metrics.code_name]) {
      if (defaultValue) {
        siteFinancialProjectionMetrics[metrics.code_name] = defaultValue;
      }
    }

    return (
      <div className="site-financial-projection-edit__attribute">
        <Label>{metrics.name}</Label>
        <Input
          disabled={
            isView ? true : false // metrics.is_calculated ? true : false
          }
          value={valueToDisplay}
          onChange={(e) =>
            this.updateAttr(
              metrics.code_name,
              metrics.metrics_type == "number" || noFormat == false
                ? e.target.value.replace(/,/g, "")
                : e.target.value
            )
          }
        />
      </div>
    );
  }
  renderSummaryMetrics(metric_code_name, modelName = "site_dev") {
    const {
      metricsList,
      siteFinancialProjectionMetrics,
      aiModelSiteFinancialProjectionMetrics,
    } = this.state;

    let modelData = siteFinancialProjectionMetrics;
    if (modelName === "site_dev") {
      modelData = siteFinancialProjectionMetrics;
    } else {
      modelData = aiModelSiteFinancialProjectionMetrics;
    }

    if (!modelData) return null;
    const metrics = metricsList.filter(
      (eachMetrics) => eachMetrics.code_name === metric_code_name
    )[0];
    if (!metrics) return null;

    const metricsValue = modelData[metric_code_name];
    let valueToDisplay = numeral(metricsValue).format("0,0");
    if (metrics.metrics_type == "percentage") {
      valueToDisplay = numeral(metricsValue).format("0.00%");
    }
    return (
      <div className="site-financial-projection-edit__attribute">
        <span className="site-financial-projection-summary_label">
          {metrics.name}:{" "}
        </span>
        <span className="site-financial-projection-summary_value">
          {valueToDisplay}
        </span>
      </div>
    );
  }
  renderSummaryView() {
    const {
      siteFinancialProjectionMetrics,
      site,
      aiModelSiteFinancialProjectionMetrics,
      isLoadingAIModelMetrics,
      sitePerformanceEstimations,
    } = this.state;

    if (!siteFinancialProjectionMetrics) return null;
    return (
      <div className="site-financial-projection-summary_container">
        <Table striped responsive>
          <thead>
            <tr>
              <th></th>
              <th>Site Dev</th>
              <th>AI Model</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td />
              <td />
              <td scope="row">
                <Button
                  size="sm"
                  color={isLoadingAIModelMetrics ? "secondary" : "primary"}
                  onClick={() => this.getAIModelSiteProjectionMetrics(true)}
                  disabled={isLoadingAIModelMetrics}
                >
                  {isLoadingAIModelMetrics ? "Running..." : "Predict"}
                </Button>
              </td>
            </tr>
            <tr>
              <td scope="row">
                {t().site_final_projection__area_target_population}
              </td>
              <td>
                {siteFinancialProjectionMetrics &&
                  Math.max(
                    parseInt(
                      siteFinancialProjectionMetrics.trade_area_target_population,
                      10
                    ),
                    parseInt(
                      siteFinancialProjectionMetrics.store_sister_target_population,
                      10
                    )
                  )}
              </td>
              <td />
            </tr>
            <tr>
              <td scope="row">
                {t().site_final_projection__estimate_ticket_monthly}
              </td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    siteFinancialProjectionMetrics.trade_area_forecasted_revenue_per_day_value <
                      siteFinancialProjectionMetrics.store_sister_forecasted_revenue_per_day_value
                      ? (siteFinancialProjectionMetrics.trade_area_forecasted_revenue_per_day_value /
                          siteFinancialProjectionMetrics.trade_area_average_ticket_value) *
                          0.75 *
                          30
                      : (siteFinancialProjectionMetrics.store_sister_forecasted_revenue_per_day_value /
                          siteFinancialProjectionMetrics.store_sister_average_ticket_value) *
                          0.75 *
                          30
                  ).format("0,0")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.estimated_instore_tickets_per_month_value
                  ).format("0,0")}
              </td>
            </tr>
            <tr>
              <td scope="row">
                {t().site_final_projection__average_ticket_value}
              </td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    Math.max(
                      parseFloat(
                        siteFinancialProjectionMetrics.trade_area_average_ticket_value
                      ),
                      parseFloat(
                        siteFinancialProjectionMetrics.store_sister_average_ticket_value
                      )
                    )
                  ).format("0,0")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.average_instore_ticket_value
                  ).format("0,0")}
              </td>
            </tr>
            <tr>
              <td scope="row">
                {t().site_final_projection__estimate_revenue_monthly}
              </td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    siteFinancialProjectionMetrics.final_forecasted_revenue_per_month_value
                  ).format("0,0")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.final_forecasted_revenue_per_month_value
                  ).format("0,0")}
              </td>
            </tr>
            <tr>
              <td scope="row">Gross Profit</td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    siteFinancialProjectionMetrics.estimated_gross_profit_value
                  ).format("0,0")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.estimated_gross_profit_value
                  ).format("0,0")}
              </td>
            </tr>
            <tr>
              <td scope="row">
                {t().site_final_projection__estimate_ebitda_monthly}
              </td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    siteFinancialProjectionMetrics.estimated_ebitda_value
                  ).format("0,0")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.estimated_ebitda_value
                  ).format("0,0")}
              </td>
            </tr>
            <tr>
              <td scope="row">EBITDA / Revenue</td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    siteFinancialProjectionMetrics.estimated_ebitda_over_revenue_pct
                  ).format("0.00%")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.estimated_ebitda_over_revenue_pct
                  ).format("0.00%")}
              </td>
            </tr>
            <tr>
              <td scope="row">% Rental Cost</td>
              <td>
                {siteFinancialProjectionMetrics &&
                  numeral(
                    siteFinancialProjectionMetrics.rental_cost_pct
                  ).format("0.00%")}
              </td>
              <td>
                {aiModelSiteFinancialProjectionMetrics &&
                  numeral(
                    aiModelSiteFinancialProjectionMetrics.rental_cost_pct
                  ).format("0.00%")}
              </td>
            </tr>
          </tbody>
        </Table>
        {/* {site && site.brand && site.brand.brand_code == "TCH" && (
          <Col xs={12}>
            <a href={`/sitev2/${site.id}/estimate-ebitda-tc`}>
              Ước tính doanh thu theo EBITDA mong muốn
            </a>
          </Col>
        )} */}
      </div>
    );
  }
  render() {
    const { sisterStore } = this.state;
    const { showSummaryOnly, isView } = this.props;

    if (showSummaryOnly) {
      return (
        <div
          className={`site-financial-projection-container ${
            showSummaryOnly ? "showSummaryOnly" : ""
          }`}
        >
          {this.renderSummaryView()}
        </div>
      );
    }
    return (
      <TabPane tabId="site_financial_projection_tab" style={{}}>
        <div className="site-financial-projection-container">
          {false && (
            <Row>
              <Col xs={12}>
                <Button color="info" onClick={() => this.saveData()}>
                  {t().action__save_and_calculation}
                </Button>
              </Col>
            </Row>
          )}
          {this.renderSummaryView()}
          <div className="site-edit__section">
            <h2 className="site-edit__section-title">
              {t().site_final_projection__trade_area_analysis}
            </h2>
            <Row>
              <Col xs={12} sm={6}>
                {this.renderMetrics("trade_area_target_population")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("trade_area_average_group_size", true)}
              </Col>
              <Col xs={12}>
                {this.renderMetrics("trade_area_average_ticket_value")}
              </Col>
              <Col xs={12}>
                {this.renderMetrics(
                  "trade_area_forecasted_revenue_per_day_value"
                )}
              </Col>
            </Row>
          </div>
          <div className="site-edit__section">
            <h2 className="site-edit__section-title">
              {t().site_final_projection__store_sister}
            </h2>
            <Row>
              <Col xs={12} sm={6}>
                <Label>{t().site_final_projection__select_store_sister}</Label>
                <FormGroup>
                  <DataCombobox
                    disabled={isView}
                    apiUrl={`store/?q=(page:0,page_size:1000,order_columns:created_on,order_direction:desc,filters:!((col:is_active,opr:eq,value:1),(col:brand,opr:rel_o_m,value:1)))`}
                    onChange={(store) => this.setSisterStore(store)}
                    placeholder={t().site_listing__search_name_placeholder}
                    value={{
                      label: sisterStore ? sisterStore.name : "",
                      value: sisterStore ? sisterStore.id : "",
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6}>
                {this.renderMetrics("store_sister_target_population")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("store_sister_average_group_size", true)}
              </Col>
              <Col xs={12}>
                {this.renderMetrics("store_sister_average_ticket_value")}
              </Col>
              <Col xs={12}>
                {this.renderMetrics(
                  "store_sister_forecasted_revenue_per_day_value"
                )}
              </Col>
              <Col xs={12}>
                {this.renderMetrics("final_forecasted_revenue_per_day_value")}
              </Col>
            </Row>
          </div>
          <div className="site-edit__section">
            <h2 className="site-edit__section-title">
              {t().site_detail__tab_financial_projection}
            </h2>
            <Row>
              <Col xs={12}>
                {this.renderMetrics("usd_vnd_exchange_rate", false, 23300)}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("investment_cost_square_meters")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("investment_cost")}
              </Col>
              <Col xs={12}>{this.renderMetrics("equipment_cost")}</Col>
              <Col xs={12}>{this.renderMetrics("pre_opening_cost")}</Col>
              <Col xs={12}>{this.renderMetrics("rent_deposit")}</Col>
              <Col xs={12}>{this.renderMetrics("total_capex")}</Col>
              <Col xs={12}>{this.renderMetrics("total_cash_needed")}</Col>
            </Row>
          </div>
          <div className="site-edit__section">
            <h2 className="site-edit__section-title">
              {t().site_final_projection__operation_cost}
            </h2>
            <Row>
              <Col xs={12} sm={6}>
                {this.renderMetrics("cogs_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("cogs_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("gross_margin_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("gross_margin_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("labor_cost_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("labor_cost_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("rental_cost_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("rental_cost_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("utilities_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("utilities_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("other_opex_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("other_opex_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("marketing_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("marketing_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("maintenance_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("maintenance_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("reinvesment_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("reinvesment_value")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("depreciation_pct")}
              </Col>
              <Col xs={12} sm={6}>
                {this.renderMetrics("depreciation_value")}
              </Col>
            </Row>
            {false && (
              <Row>
                <Col xs={12}>
                  <Button color="info" onClick={() => this.saveData()}>
                    {t().action__save_and_calculation}
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </TabPane>
    );
  }
}
